import React from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import VstListItem from './VstListItem';

class VstPopover extends React.Component {
  constructor(props) {
    super(props);

    this.createPortal = this.createPortal.bind(this);
    this.onDocumentMouseUp = this.onDocumentMouseUp.bind(this);
  }

  componentDidMount() {
    this.createPortal();
    this.doRender(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.doRender(nextProps);
  }

  componentWillUnmount() {
    if (this.portal) {
      ReactDOM.unmountComponentAtNode(this.portal);
      document.body.removeChild(this.portal);
    }
  }

  render() {
    return null;
  }

  createPortal() {
    this.portal = document.createElement('div');
    this.portal.setAttribute('class', 'vst-popover');
    document.body.appendChild(this.portal);
  }

  doRender(props) {
    ReactDOM.render(
      this.renderComponent(props),
      this.portal
    );
  }

  onDocumentMouseUp(e) {
    const portal = findDOMNode(this.portal);
    if (portal && portal.contains(e.target) || (e.button && e.button !== 0)) return;
    e.stopPropagation();
  }

  renderComponent(props) {
    const { className, style, children, onBackdropClick, showOverlay, ...restProps } = props;

    return (
      <div>
        {showOverlay && <div className="vst-popover-overlay" onClick={onBackdropClick} />}
        <div
          style={{ position: 'fixed', ...style }}
          className={`vst-list ${className}`}
          {...restProps}
        >
          {children}
        </div>
      </div>
    );
  }
}

VstPopover.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  showOverlay: PropTypes.bool,
  style: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  })
};

VstPopover.defaultProps = {
  className: '',
  open: false,
  showOverlay: false,
  style: {}
};

VstPopover.Item = VstListItem;

export default VstPopover;
